// extracted by mini-css-extract-plugin
export default {"block-iframe-wrapper":"styles_block-iframe-wrapper__7DNSd"};